import styles from "../../../styles/Participant-GPRA.module.css"
import EnterpriseLibrarySidebar from "../../../components/sidebars/EnterpriseLibrarySidebar"
import PageSidebarContent from "../../../components/sidebars/PageSidebarContent"
import { TabView, TabPanel } from "primereact/tabview"
import { Accordion, AccordionTab } from "primereact/accordion"
import Questions from "./Questions"
import { useContext, useCallback, useState, useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import axios from "axios"
import { gpraUrl } from "../../../config/microservicesUrls"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_TYPES } from "../types/interviewTypes"
import { MultiSelect } from "primereact/multiselect"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { gql, useQuery } from "@apollo/client"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { Toast } from "primereact/toast"
import { useRef } from "react"
import { showMessage } from "../utils/utils"
import { convertAdditionalQuestionsOptions } from "../utils/utils"
import { Checkbox } from "primereact/checkbox"
import { sectionsDictionary } from "./sectionsDictionary"

const Configuration = () => {
  const userCtx = useContext(UserContext)
  const [loading, setLoading] = useState()
  const [loadingCustomizations, setLoadingCustomizations] = useState()
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedOrganizations, setSelectedOrganizations] = useState([])
  const [initialSelectedOrganizations, setInitialSelectedOrganizations] =
    useState([])
  const [organizations, setOrganizations] = useState([])
  const [
    disabledCustomizationsVisibility,
    setDisabledCustomizationsVisibility,
  ] = useState(true)
  const [organizationError, setOrganizationError] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [applyCustomizations, setApplyCustomizations] = useState(false)
  const [customizationChanges, setCustomizationChanges] = useState(false)
  const [saving, setSaving] = useState(false)
  const [defaultZero, setDefaultZero] = useState(false)
  const [defaultZeroUpdated, setDefaultZeroUpdated] = useState(false)
  const [customizations, setCustomizations] = useState([])
  const [interviewType, setInterviewType] = useState()
  const [loadCustomizations, setLoadCustomizations] = useState(true)
  const [sectionOrders, setSectionOrders] = useState(null)
  const [questions, setQuestions] = useState({
    additionalQuestions: [],
    customizations: [],
    matrices: [],
    groups: [],
  })
  const [blocked, setBlocked] = useState(false)
  const [pollServer, setPollServer] = useState(false)
  useEffect(() => {
    switch (activeIndex) {
      case 0:
        return setInterviewType(INTERVIEW_TYPES.INTAKE)
      case 1:
        return setInterviewType(INTERVIEW_TYPES.FOLLOW_UP)
      case 2:
        return setInterviewType(INTERVIEW_TYPES.DISCHARGE)
      default:
        break
    }
  }, [activeIndex])

  useEffect(() => {
    setLoadCustomizations(true)
  }, [interviewType])

  useEffect(() => {
    if (
      userCtx.session.user.organization_id !==
      userCtx.session.user.enterprise_id
    ) {
      setDisabledCustomizationsVisibility(true)
    }
    setLoadCustomizations(true)
  }, [userCtx.session.user.organization_id, userCtx.session.user.enterprise_id])

  const checkVisibility = useCallback(
    (data) => {
      if (
        userCtx.session.user.organization_id !==
        userCtx.session.user.enterprise_id
      ) {
        if (
          data?.length > 0 &&
          data?.every((c) => !c.enterpriseCustomization) &&
          data?.every((c) => !c.isEnterprise)
        ) {
          setDisabledCustomizationsVisibility(false)
        }
      } else {
        setDisabledCustomizationsVisibility(false)
      }
    },
    [userCtx.session.user.enterprise_id, userCtx.session.user.organization_id],
  )
  const getCustomizations = useCallback(() => {
    if (
      userCtx.session.user.organization_id &&
      organizations?.length > 0 &&
      loadCustomizations
    ) {
      setLoadingCustomizations(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
      }
      axios
        .post(
          `${gpraUrl()}${endpoints.GET_CUSTOMIZATIONS}`,
          {
            organization_id: userCtx.session.user.organization_id,
            interview_type: interviewType,
            organizations: organizations[0]?.items.map((o) => o.value),
          },
          config,
        )
        .then((response) => {
          if (response.status === 200) {
            checkVisibility(
              response?.data?.customizations?.map((c) => {
                return {
                  enterpriseCustomization: c.enterpriseCustomization,
                  isEnterprise: c.isEnterprise,
                }
              }),
            )
            setCustomizations(response.data.customizations)
            if (response.data.lastOrganizations?.length > 0 && !blocked) {
              setSelectedOrganizations(response.data.lastOrganizations)
              setInitialSelectedOrganizations(response.data.lastOrganizations)
            }
            if (response.data.customizations?.some((c) => c.defaultZero)) {
              setDefaultZero(true)
            }
          }
          setLoadingCustomizations(false)
          setLoadCustomizations(false)
        })
        .catch(() => {
          setLoadingCustomizations(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userCtx.session.user.organization_id,
    interviewType,
    checkVisibility,
    organizations,
    loadCustomizations,
  ])
  const toast = useRef(null)

  useEffect(() => {
    if (sectionOrders) {
      let blocked = false
      if (!isEnterprise()) {
        blocked = !!sectionOrders.checkStatus?.blockedOrganizations?.find(
          (o) => o.organizationUuid === userCtx.session.user.organization_id,
        )
      } else {
        blocked = sectionOrders.checkStatus?.blocked
      }
      setBlocked(blocked)
      if (blocked) {
        setPollServer(true)
      }
      const section_additionalQuestions = sectionOrders.sectionsOrders
        .filter((a) => !!a.additionalQuestion)
        .map((a) => {
          return {
            ...a.additionalQuestion,
            groupOrder: a.additionalQuestion.questionGroup ? a.orderNumber : 1,
            number: !a.additionalQuestion.questionGroup ? a.orderNumber : 0,
          }
        })

      const section_matrices = sectionOrders.sectionsOrders
        .filter((a) => !!a.matrixGroup)
        .map((a) => {
          return { ...a.matrixGroup, number: a.orderNumber }
        })

      const section_groups = sectionOrders.sectionsOrders
        .filter((a) => !!a.questionGroup)
        .map((a) => {
          return {
            ...a.questionGroup,
            groupOrder: a.questionGroup.matrixGroup ? a.orderNumber : 1,
            number: !a.questionGroup.matrixGroup ? a.orderNumber : 0,
          }
        })
      checkVisibility(
        section_additionalQuestions?.map((a) => {
          return {
            enterpriseCustomization: a.enterpriseCustomization,
            isEnterprise: a.isEnterprise,
          }
        }),
      )
      setQuestions({
        ...questions,
        additionalQuestions: section_additionalQuestions,
        matrices: section_matrices,
        groups: section_groups,
        customizations: customizations,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionOrders, customizations])
  useEffect(() => {
    getCustomizations()
  }, [getCustomizations])

  const getSections = useCallback(() => {
    if (userCtx.session.user.organization_id) {
      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
        params: {
          organization_uuid: userCtx.session.user.organization_id,
          form: interviewType,
          staff_id: userCtx.session.user.staff_id,
        },
      }
      axios
        .get(`${gpraUrl()}${endpoints.GET_SECTIONS_ORDERS}`, config)
        .then((response) => {
          if (response.status === 200) {
            setSectionOrders(response.data)
          }
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [
    interviewType,
    userCtx.session.user.organization_id,
    userCtx.session.user.staff_id,
  ])

  useEffect(() => {
    getSections()
  }, [getSections])

  const GET_ORGANIZATIONS = gql`
    query Organizations($staff_id: ID!, $organization_id: ID!) {
      organizations: statsOrganizationsByUid(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        value: organization_id
        label: organization_name
      }
    }
  `
  const sortOrganizations = (a, b) => {
    if (a.label < b.label) {
      return -1
    }
    if (a.label > b.label) {
      return 1
    }
    return 0
  }
  const getOrgs = useQuery(GET_ORGANIZATIONS, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.enterprise_id,
    },
    context: {
      headers: {},
    },
    skip: !userCtx,
    fetchPolicy: "network-only",
    onCompleted: (o) => {
      const orgs = {
        label: "Organizations",
        items: o.organizations
          .filter((o) => o.value !== userCtx.session.user.enterprise_id)
          .sort(sortOrganizations),
      }
      setOrganizations([orgs])
    },
  })
  const isEnterprise = useCallback(() => {
    return (
      userCtx.session.user.organization_id ===
      userCtx.session.user.enterprise_id
    )
  }, [userCtx.session.user.enterprise_id, userCtx.session.user.organization_id])

  const setOrganizationsToSave = useCallback(() => {
    let orgsToSave = []
    if (isEnterprise()) {
      orgsToSave = selectedOrganizations?.map((o) => {
        return {
          organizationId: o,
          isEnterprise: o === userCtx.session.user.enterprise_id,
          enterpriseCustomization: isEnterprise(),
        }
      })
      orgsToSave.push({
        organizationId: userCtx.session.user.enterprise_id,
        isEnterprise: true,
        enterpriseCustomization: true,
      })
    } else {
      orgsToSave.push({
        organizationId: userCtx.session.user.organization_id,
        isEnterprise: false,
        enterpriseCustomization: false,
      })
    }

    return orgsToSave
  }, [
    isEnterprise,
    selectedOrganizations,
    userCtx.session.user.enterprise_id,
    userCtx.session.user.organization_id,
  ])
  const getAllOrganizations = () => {
    let all = []
    if (
      userCtx.session.user.enterprise_id ===
      userCtx.session.user.organization_id
    ) {
      if (organizations && organizations.length > 0) {
        all = [
          userCtx.session.user.enterprise_id,
          ...organizations[0]?.items.map((o) => o.value),
        ]
      }
    } else {
      all = [userCtx.session.user.organization_id]
    }
    return all
  }
  const convertOptions = (options) => {
    if (!Array.isArray(options)) {
      if (options) {
        return convertAdditionalQuestionsOptions(options)
      } else {
        return []
      }
    }
    return options
  }
  const buildAdditionalQuestions = (additional, matrices, groups) => {
    const additionalEntities = additional?.map((question) => {
      return {
        Id: question.id,
        OrganizationUuid: question.organizationUuid,
        Form: question.form,
        Section: question.section,
        SubSection: question.subSection,
        Title: question.title,
        OldTitle: !question.oldTitle ? question.title : question.oldTitle,
        Description: question.description,
        Type: question.type,
        Options: convertOptions(question.options),
        Enabled: question.enabled,
        Required: question.required,
        Number: question.questionGroup ? question.groupOrder : question.number,
        Deleted: question.deleted,
        DefaultZero: defaultZero,
        SectionOrder: {
          OrderNumber: !!question.questionGroup
            ? question.groupOrder
            : question.number,
          Id: question.section.id,
        },
        GroupOrder: question.groupOrder,
        QuestionGroup: {
          alignment: question.questionGroup?.alignment,
          enabled: question.questionGroup?.enabled,
          enterpriseCustomization:
            question.questionGroup?.enterpriseCustomization,
          form: question.questionGroup?.form,
          groupOrder: question.questionGroup?.groupOrder,
          id: question.questionGroup?.id,
          isEnterprise: question.questionGroup?.isEnterprise,
          organizationUuid: question.questionGroup?.organizationUuid,
          required: question.questionGroup?.required,
          section: question.questionGroup?.section,
          title: question.questionGroup?.title,
          updatedAt: question.questionGroup?.updatedAt,
        },
        ConditionalSource: question.conditionalSource,
        ConditionalType: question.conditionalType,
        ConditionalValue: question.conditionalValue,
        ConditionalRequired: question.conditionalRequired,
        ConditionalDisplay: question.conditionalDisplay,
      }
    })
    const matrixEntities = matrices?.map((matrix) => {
      return {
        Id: matrix.id,
        OrganizationUuid: matrix.organizationUuid,
        Form: matrix.form,
        Section: matrix.section,
        Title: matrix.title,
        OldTitle: !matrix.oldTitle ? matrix.title : matrix.oldTitle,
        Enabled: matrix.enabled,
        Expanded: matrix.expanded,
        Required: matrix.required,
        Deleted: matrix.deleted,
        SectionOrder: { OrderNumber: matrix.number },
      }
    })
    const groupsEntities = groups?.map((group) => {
      return {
        Id: group.id,
        OrganizationUuid: group.organizationUuid,
        Form: group.form,
        Section: group.section,
        Title: group.title,
        OldTitle: !group.oldTitle ? group.title : group.oldTitle,
        Enabled: group.enabled,
        Expanded: group.expanded,
        Required: group.required,
        Deleted: group.deleted,
        SectionOrder: {
          OrderNumber: group.matrixGroup ? group.groupOrder : group.number,
          Id: group.section.id,
        },
        Alignment: group.alignment,
        GroupOrder: group.groupOrder,
        MatrixGroup: {
          enabled: group.matrixGroup?.enabled,
          enterpriseCustomization: group.matrixGroup?.enterpriseCustomization,
          form: group.matrixGroup?.form,
          id: group.matrixGroup?.id,
          isEnterprise: group.matrixGroup?.isEnterprise,
          organizationUuid: group.matrixGroup?.organizationUuid,
          required: group.matrixGroup?.required,
          section: group.matrixGroup?.section,
          title: group.matrixGroup?.title,
          updatedAt: group.matrixGroup?.updatedAt,
        },
      }
    })
    return {
      AdditionalEntities: additionalEntities,
      AdditionalMatrices: matrixEntities,
      AdditionalGroups: groupsEntities,
      SelectedOrganizations: setOrganizationsToSave(),
    }
  }
  const checkStatus = useCallback(
    (safeCheck, organizations) => {
      const config = {
        headers: {
          Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
        },
      }
      axios
        .post(
          `${gpraUrl()}${endpoints.CHECK_ADDITIONAL_STATUS}`,
          {
            organization_uuid: userCtx.session.user.organization_id,
            organizations: organizations,
            staff_id: userCtx.session.user.staff_id,
          },
          config,
        )
        .then((response) => {
          if (!response?.data?.blocked) {
            setInitialSelectedOrganizations(response?.data?.lastOrganizations)
            setSelectedOrganizations(response?.data?.lastOrganizations)
            setBlocked(response?.data?.blocked)
            setPollServer(false)
          }
          if (response?.data?.blocked && safeCheck) {
            userCtx.setNotificationError(
              "Additional questions save process failed. Please contact support service.",
            )
          }
        })
    },
    [userCtx],
  )

  useEffect(() => {
    let intervalId
    if (pollServer) {
      intervalId = setInterval(() => {
        checkStatus(
          false,
          organizations[0]?.items.map((o) => o.value),
        )
      }, 5000)
    } else {
      clearInterval(intervalId)
    }
    return () => {
      clearInterval(intervalId)
    }
  }, [pollServer, checkStatus, organizations])

  const apply = useCallback(
    (
      orgLevel,
      additional,
      matrices,
      groups,
      customizations,
      interview_type,
    ) => {
      if (applyCustomizations || orgLevel) {
        setSaving(true)
        const organizationsToSave = setOrganizationsToSave()
        const config = {
          headers: {
            Authorization: `Bearer ${userCtx.tokens.getGpraToken()}`,
          },
          timeout: 300000,
        }
        axios
          .post(
            `${gpraUrl()}${endpoints.SAVE_CUSTOMIZATIONS}`,
            {
              DefaultQuestionsSave: {
                Customizations: orgLevel
                  ? customizations
                  : questions.customizations,
                SelectedOrganizations: organizationsToSave,
                All: true,
                DefaultZero: defaultZero,
              },
              AdditionalQuestionsSave: buildAdditionalQuestions(
                additional,
                matrices,
                groups,
              ),
              Organizations: getAllOrganizations(),
              OrganizationUuid: userCtx.session.user.organization_id,
              UserId: userCtx.session.user.staff_id,
              Form: interviewType,
            },
            config,
          )
          .then((response) => {
            if (response.status === 200) {
              setTimeout(
                () => {
                  checkStatus(
                    true,
                    organizations[0]?.items.map((o) => o.value),
                  )
                },
                15 * 60 * 1000,
              )
              setApplyCustomizations(false)
              setShowConfirm(false)
              setCustomizationChanges(false)
              setSaving(false)
              setSectionOrders(response.data.additionalSectionOrders)
              setCustomizations(response.data.customizations)
              setLoadCustomizations(true)
              setDefaultZeroUpdated(false)
              toast.current.show({
                severity: "success",
                summary: "",
                detail: "Customizations updated",
              })
            }
          })
          .catch((err) => {
            setSaving(false)
            setShowConfirm(false)
            setApplyCustomizations(false)
            showMessage(false, err?.response?.data, toast)

            if (
              err?.response?.data?.duplicatedGroups ||
              err?.response?.data?.duplicatedMatrices ||
              err?.response?.data?.duplicatedQuestions
            ) {
              showMessage(
                false,
                "Entities duplication detected. Saving process aborted. Please contact support.",
                toast,
              )
            }
          })
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      questions.customizations,
      setOrganizationsToSave,
      userCtx.session.user.staff_id,
      applyCustomizations,
    ],
  )

  useEffect(() => {
    apply(
      false,
      questions?.additionalQuestions,
      questions?.matrices,
      questions?.groups,
      interviewType,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apply])

  const footerContent = () => {
    return (
      <div>
        <Button
          label="No"
          icon={"pi pi-times"}
          onClick={() => setShowConfirm(false)}
          className="p-button-text"
          disabled={applyCustomizations}
        />
        <Button
          label="Yes"
          icon={applyCustomizations ? "pi pi-spin pi-spinner" : "pi pi-check"}
          onClick={() => {
            setApplyCustomizations(true)
          }}
          disabled={applyCustomizations}
          autoFocus
        />
      </div>
    )
  }
  const confirmDialogContent = () => {
    if (!blocked) {
      if (!isEnterprise()) {
        return (
          <div>
            <p className="m-0">Are you sure you want to save the changes?</p>
          </div>
        )
      } else {
        return (
          <>
            <p className="m-0">
              Are you sure you want to update links for the selected (and
              deselected) organizations? This may take a moment to complete but
              the majority of the process will run in the background and you
              will be notified when everything is complete.
            </p>
            <p className="m-0" style={{ marginTop: "1rem" }}>
              Please note:
              <i>
                {" "}
                Any previously linked organizations that have been deselected
                will retain their current customization settings and will be
                able to change them at the organizational level.
              </i>
            </p>
          </>
        )
      }
    } else {
      return (
        <p
          className="m-0"
          style={{ marginBottom: "1rem", marginTop: "1rem", fontSize: "16px" }}
        >
          Some background sync/save jobs are still running, please try again in
          a few minutes
        </p>
      )
    }
  }
  const confirmDialog = () => {
    return (
      <div className="card flex justify-content-center">
        <Dialog
          header={!blocked && "Please confirm"}
          visible={showConfirm}
          style={{ width: "40vw" }}
          onHide={() => setShowConfirm(false)}
          footer={!blocked && footerContent}
        >
          {confirmDialogContent()}
        </Dialog>
      </div>
    )
  }
  const updateShowCustomizations = (questionId, value) => {
    const newSave = questions.customizations?.map((s) => {
      let newValue = { ...s }
      if (s.id === questionId) {
        newValue.show = value
      }
      return newValue
    })
    setQuestions({ ...questions, customizations: newSave })
    setCustomizationChanges(true)
  }
  const newChanges = () => {
    return (
      JSON.stringify(initialSelectedOrganizations.sort()) !==
        JSON.stringify(selectedOrganizations.sort()) || defaultZeroUpdated
    )
  }
  const applySelector = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "5px",
          }}
        >
          <MultiSelect
            showSelectAll
            disabled={disabledCustomizationsVisibility || blocked}
            value={selectedOrganizations}
            options={organizations}
            placeholder="Select an Organization"
            optionLabel="label"
            optionGroupLabel="label"
            optionGroupChildren="items"
            maxSelectedLabels={4}
            onChange={(e) => {
              setSelectedOrganizations(e.target.value)
              setOrganizationError(false)
            }}
          />
          <Button
            label="Update Link"
            disabled={
              !organizations ||
              organizations.length === 0 ||
              !newChanges() ||
              blocked
            }
            onClick={() => {
              setShowConfirm(true)
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <Checkbox
            inputId="defaultZero"
            disabled={blocked}
            onChange={(e) => {
              setDefaultZero(e.checked)
              setDefaultZeroUpdated(true)
            }}
            checked={defaultZero}
          />
          <label htmlFor="defaultZero" style={{ marginLeft: "1rem" }}>
            Default all numeric fields to 0 (zero)
          </label>
        </div>
        <label>
          Once an organization is linked, changes made at the enterprise level
          to the GPRA will be propagated to any linked organizations
          automatically upon saving the customizations.
        </label>
      </>
    )
  }
  const updateQuestions = (data) => {
    let updatedMatrices = []
    let updatedGroups = []
    updatedGroups = data?.groups?.map((group) => {
      const matrixGroup = () => {
        if (!group.deleted) {
          if (!group.matrixGroup) {
            return data?.matrices?.find((m) => m.title === group.matrixId)
          }
          return group.matrixGroup
        } else {
          return null
        }
      }
      return {
        ...group,
        matrixGroup: matrixGroup(),
        additionalQuestions: group.deleted ? [] : group.additionalQuestions,
      }
    })
    updatedMatrices = data.matrices
      ?.map((m) => {
        const groups = updatedGroups?.filter(
          (g) => g?.matrixGroup?.title === m.title && !g.deleted,
        )
        let newValue = { ...m }
        newValue.questionGroups = groups
        return newValue
      })
      .sort((a, b) => {
        return a.number - b.number
      })

    setQuestions({
      ...questions,
      matrices: updatedMatrices,
      groups: updatedGroups,
      additionalQuestions: data?.additionalQuestions,
      customizations: data?.customizations,
    })
    setCustomizationChanges(true)
  }
  const saveView = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "1rem",
            marginBottom: "1rem",
            gap: "1rem",
          }}
        >
          <Checkbox
            inputId="defaultZero"
            onChange={(e) => {
              setDefaultZero(e.checked)
            }}
            checked={defaultZero}
          />
          <label htmlFor="defaultZero" style={{ marginLeft: "0.5rem" }}>
            Default all numeric fields to 0 (zero)
          </label>
          <Button
            label="Save"
            onClick={() => {
              setShowConfirm(true)
            }}
          />
        </div>
      </>
    )
  }
  const mainContent = () => {
    return (
      <>
        <Toast ref={toast} />
        {!disabledCustomizationsVisibility && isEnterprise() && applySelector()}
        {!disabledCustomizationsVisibility && !isEnterprise() && saveView()}
        <div className={gpraStyles.mt2}>
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
          >
            {sectionsDictionary.map((main) => {
              return (
                <TabPanel header={main.title}>
                  <Accordion>
                    {main.sections.map((section) => {
                      return (
                        <AccordionTab header={section.title}>
                          <Questions
                            selectedOrganizations={setOrganizationsToSave()}
                            organizations={getAllOrganizations()}
                            organizationError={organizationError}
                            setOrganizationError={setOrganizationError}
                            disabled={disabledCustomizationsVisibility}
                            updateShowCustomizations={updateShowCustomizations}
                            interviewType={section.interviewType}
                            section={section.section}
                            setCustomizationChanges={setCustomizationChanges}
                            customizationChanges={customizationChanges}
                            apply={apply}
                            saving={saving}
                            updateQuestions={updateQuestions}
                            questions={questions}
                            blocked={blocked}
                          />
                        </AccordionTab>
                      )
                    })}
                  </Accordion>
                </TabPanel>
              )
            })}
          </TabView>
        </div>
      </>
    )
  }
  if (loading || getOrgs.loading || loadingCustomizations) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <div>
      <PageSidebarContent>
        <EnterpriseLibrarySidebar />
      </PageSidebarContent>
      <div className="main-content">
        <h1 className={styles.title}>GPRA configuration</h1>
        {mainContent()}
        {confirmDialog()}
      </div>
    </div>
  )
}
export default Configuration
